// removed by extract-text-webpack-plugin
module.exports = {"root":"Logo__root--2oxmq","icon":"Logo__icon--1S1Zz"};


//////////////////
// WEBPACK FOOTER
// ./src/client/src/components/Logo.scss
// module id = 337
// module chunks = 0